import { Component, OnInit } from '@angular/core';
import { TramitesService } from 'src/app/servicios/tramites.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Loading } from 'src/app/Class/Loading';
declare var $:any;

@Component({
  selector: 'app-detalle-tramite',
  templateUrl: './detalle-tramite.component.html',
  styleUrls: ['./detalle-tramite.component.css']
})

export class DetalleTramiteComponent implements OnInit  {
  public id: number;
  public tramite: any = [];
  public historial: any = [];
  router: any; 
  public serve : any;
  public estados: FormGroup;
  public estadosAux: any = [];
  public estadosSelect: any = [];
  
  
  public foto: string;
  constructor(private tramiteService: TramitesService,  private rout: ActivatedRoute, private route: Router, private form: FormBuilder, public loading: Loading) { 
   
    this.loading.estado = true;

    this.rout.params.subscribe(params => { this.id = params['id']; });
   
    this.estados = this.form.group({
      tramite_id:  ['', Validators.required],
      estado_anterior_id: ['', Validators.required],
      estado_nuevo_id: ['', Validators.required],
      observacion: [''],
      soporte:['']
    })
   
    this.serve = this.tramiteService.getServe();
   
    this.tramiteService.getDetalle(this.id).subscribe(data => {
      if(data['success']){
        this.tramite  = data['data']['tramite'];
        this.foto = this.tramite.persona_foto ? this.serve +  this.tramite.persona_foto : null;
        this.historial = data['data']['historial'];
        this.estadosAux = data['data']['estados'];
      }
      else{
        Swal.fire({
          type: 'error',
          title:'Error',
          text: 'Trámite no disponible',
          showConfirmButton: false,
          timer: 1500
        });     
        this.route.navigate(['/dashboard']);
      }
      this.loading.estado = false;
    });
  }

  ngOnInit() {
  }
  
  modalCEstado(tramite_id, estado_id, peso){
    $('#modalEstado').modal({ backdrop: 'static', keyboard: true, show: true });
    this.estados.get('estado_anterior_id').setValue(estado_id);
    this.estadosSelect = this.estadosAux.filter(row => row.id != estado_id && row.peso > peso);
    this.estados.get('tramite_id').setValue(this.id);
  }
  
  cambiarEstado(){
  
    this.loading.estado = true;
  
    var formData = new FormData();
    for( var nombre in this.estados.value ) { 
      formData.append(nombre, this.estados.value[nombre]); 
    }
    this.tramiteService.cambiarEstado(formData).subscribe(data => {
      $('#modalEstado').modal('hide');
      if(data['success'] == true){
        Swal.fire({
          type: 'success',
          title: 'Cambio de estado',
          text: 'Cambio de estado exitoso',
          showConfirmButton: false,
          timer: 1500
        });
        this.route.navigate(['/tramites/detalleTramite/'+this.estados.value.tramite_id]);
      }
      else{
        Swal.fire({
          type: 'error',
          title:'Error',
          text: 'No se completó su solicitud',
          showConfirmButton: false,
          timer: 1500});
      }  
      this.loading.estado = false;    
    });
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.estados.get('soporte').setValue(file);
    }
  }
   
}
